import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import type { ComponentType, ReactElement } from "react";
import type { QueryKey, QueryStatus } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";

type QueryData = Iterable<unknown>;

type QueryKeyFn = (params?: unknown) => QueryKey;

type HocProps = { status: QueryStatus | undefined };

const withQueryDataCell = <P extends ITableCellProps>(
    queryKeyFn: QueryKeyFn,
    CellComponent: ComponentType<P & HocProps>,
) => {
    return function WrappedWithQueryDataCell(props: P): ReactElement {
        const queryClient = useQueryClient();

        const { status, data } = queryClient.getQueryState<QueryData>(queryKeyFn(props)) ?? {};

        const isCellDisabled = status === "pending";
        const enrichedRow = typeof data === "undefined" ? props.row : { ...props.row, ...data }; //TODO should memo?

        return (
            <CellComponent
                {...props}
                row={enrichedRow}
                status={status}
                disabled={isCellDisabled}
            />
        );
    };
};

export default withQueryDataCell;
